import AbstractElement from "./AbstractElement";
import SectionTab from "../components/tab/SectionTab";
import CarouselTab from "../components/tab/CarouselTab";
import AuraProduct from "../components/product/AuraProduct";
import Product from "../components/product/Product";
import MosaicEffect from "../components/MosaicEffect";
import CSSTransitionInElement from "../components/CSSTransitionInElement";
import TabProduct from "../components/product/TabProduct";


class PersonalizeElement extends AbstractElement {


    constructor(template: JQuery) {
        super(template);
    }

    update(scrollTop?: number): void {
        if (this.banner) this.banner.update(scrollTop, window.innerHeight / 3);
        if (this.title) this.title.update(scrollTop, window.innerHeight / 3);
        if (this.desc) this.desc.update(scrollTop, window.innerHeight / 3);
        if (this.divider) this.divider.update(scrollTop, window.innerHeight / 2);
        if (this.mosaic) this.mosaic.update(scrollTop, window.innerHeight / 3);
    }

    private banner: CSSTransitionInElement;
    private title: CSSTransitionInElement;
    private desc: CSSTransitionInElement;
    private divider: CSSTransitionInElement;
    private mosaic: MosaicEffect;

    init(): void {
        const $intro = this.template.find('.section__intro');
        this.banner = new CSSTransitionInElement($intro.find('.section__banner'));
        this.title = new CSSTransitionInElement($intro.find('.section__info__title'));
        this.desc = new CSSTransitionInElement($intro.find('.section__info__desc'));
        this.divider = new CSSTransitionInElement(this.template.find('.tab__divider'));
        this.mosaic = new MosaicEffect(this.template.find('.mosaic'));
        this.initTabs();
    }

    private initTabs(): void {

        const tabPersonalize = new SectionTab(this.template.find('#tabPersonalize'));
        tabPersonalize.changeBgColor('#070707');

        const tabAura = new CarouselTab(this.template.find('#tabAura'));
        tabAura.emitter.on('CAROUSEL_REFRESHED', () => {
            tabPersonalize.changeContentHeight();
        });
        tabAura.initCarousel({
            items: 1,
            loop: false,
            margin: 0,
            nav: false,
            dots: false,
            mouseDrag: false,
            touchDrag: false,
            autoHeight: true
        });


        const tabGamefirst = new CarouselTab(this.template.find('#tabGamefirst'));
        tabGamefirst.initCarousel({
            center: true,
            items: 1,
            loop: false,
            nav: false,
            dots: false,
            mouseDrag: true,
            touchDrag: true,
            responsive: {
                0: {
                    margin: 0,
                    stagePadding: 0,
                },
                1300: {
                    margin: 100,
                    stagePadding: 250,
                }
            }
        });

        const tabRamcache = new CarouselTab(this.template.find('#tabRamcache'));
        tabRamcache.initCarousel({
            center: true,
            items: 1,
            loop: false,
            nav: false,
            dots: false,
            mouseDrag: true,
            touchDrag: true,
            responsive: {
                0: {
                    margin: 0,
                    stagePadding: 0,
                },
                1300: {
                    margin: 100,
                    stagePadding: 250,
                }
            }
        });

        const tabSonic = new CarouselTab(this.template.find('#tabSonic'));
        tabSonic.initCarousel({
            center: true,
            items: 1,
            loop: false,
            nav: false,
            dots: false,
            mouseDrag: true,
            touchDrag: true,
            responsive: {
                0: {
                    margin: 0,
                    stagePadding: 0,
                },
                1300: {
                    margin: 100,
                    stagePadding: 250,
                }
            }
        });

        const tabAC = new CarouselTab(this.template.find('#tabAC'));
        tabAC.initCarousel({
            center: true,
            items: 1,
            loop: false,
            nav: false,
            dots: false,
            mouseDrag: true,
            touchDrag: true,
            responsive: {
                0: {
                    margin: 0,
                    stagePadding: 0,
                },
                1300: {
                    margin: 100,
                    stagePadding: 300,
                }
            }
        });

        const aura = new AuraProduct(this.template.find('.aura'));


        const productLivedash = new TabProduct(this.template.find('#productLivedash'));
        productLivedash.emitter.on('CAROUSEL_REFRESHED', () => {
            tabPersonalize.changeContentHeight();
        });
    }
}

export default PersonalizeElement;